import React from "react";

import PerfectScrollbar from "react-perfect-scrollbar";
import useSidebar from "../../hooks/useSidebar";
import SidebarNav from "./SidebarNav";
import { SidebarItemsType } from "../../types/sidebar";
import { Settings } from "lucide-react";
import { useAuth } from "../../contexts/AuthContext";
import { AresSettings } from "../../pages/ares/m24l/Settings/AresSettings";

interface SidebarProps {
  items: {
    title: string;
    pages: SidebarItemsType[];
  }[];
  open?: boolean;
  showFooter?: boolean;
}

const Sidebar = ({ items, showFooter }: SidebarProps) => {
  
  const {setShowOpenSettings, showOpenSettings}  = useAuth();
  const { isOpen } = useSidebar();
  
  return (
     <nav className={`sidebar ${!isOpen ? "collapsed" : ""}`}>
      <div className="sidebar-content relative h-full">
        <PerfectScrollbar className="pb-16"> 
          <SidebarNav items={items} />
        </PerfectScrollbar>
        {showFooter && (
            <>
            <button onClick={() => setShowOpenSettings(true)} className="sidebar-footer absolute bottom-0 left-0 right-0 p-4 flex items-center gap-3">
                <Settings color="white" style={{ width: "24px", height: "24px" }} />
                <span className="text-md text-white">Settings</span>
            </button>
             <AresSettings/>
            </>
        )}
      </div>
    </nav>
  );
};

export default Sidebar;
